import { openAlert } from "../components/Modal/MsgBox";

export function download(uid, targetElement) {
    fetch(`/api-tlo/file/download/${uid}`)
        .then(async (res) => {
            if (res.status !== 200) {
                throw new Error("파일을 다운로드 할 수 없습니다.");
            }

            const disposition = res.headers.get("Content-Disposition");
            let filename = "download.bin";

            if (disposition) {
                const filenameStar = disposition.match(/filename\*=UTF-8''([^;]+)/);
                if (filenameStar && filenameStar[1]) {
                    filename = decodeURIComponent(filenameStar[1]);
                } else {
                    const filenameNormal = disposition.match(/filename="([^"]+)"/);
                    if (filenameNormal && filenameNormal[1]) {
                        filename = filenameNormal[1];
                    }
                }
            }

            const blob = await res.blob();
            return { blob, filename };
        })
        .then(({ blob, filename }) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;

            const appendTarget = targetElement?.parentElement || document.body;
            appendTarget.appendChild(a);
            const clickEvent = new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window
            });
            a.dispatchEvent(clickEvent);
            a.remove();
            URL.revokeObjectURL(url);
        })
        .catch((e) => {
            openAlert(e.message);
        });
}


export const DownloadLink = ({ name = "", uid = 0 }) => {
    return (
        <button className="file gs-underline-item blue" style={{ textAlign: "left" }} onClick={(e) => download(uid, e.currentTarget)}>
            <span className="line">{name}</span>
        </button>
    )
}